module.exports = "/assets/a76abc17d321ffd94a95b8e3c73b22d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/unknown.png
// module id = 615
// module chunks = 0